module.exports = __webpack_public_path__ + "static/selbach-logo-0a2a393297791db04c09e2caff75892e.svg";